import { type IFont } from '@/version-types';

// 格式化文字名称
export const formatFontFamilyName = (name: string) => {
    return name.replace(/\./g, '');
};

export function splitStringIntoGroups(inputString, groupSize) {
    if (typeof inputString !== 'string' || inputString.length === 0 || groupSize <= 0) {
        return [];
    }
    const regexPattern = new RegExp(`.{1,${groupSize}}`, 'g');
    return inputString.match(regexPattern) || [];
}

export const checkFontIsInEditor = (fontFamily: string, editorFonts: IFont[]) => {
    const idx = editorFonts.findIndex(
        (font) => font['font_name'] === fontFamily || font['default_name'] === fontFamily,
    );
    return idx > -1;
};

/**
 * 根据传入的字体列表和编辑器中的字体列表，找出失效的字体
 * @param sourceFonts - 传入的字体列表，通常指的是图层使用的字体列表
 * @param editorFonts - 编辑器中的字体列表
 * @param options - 可选；配置项
 *  `options.treatAsLostFont` - 指定字体是否视为失效
 */
export const findLostFonts = (
    sourceFonts: string[],
    editorFonts: IFont[],
    options?: {
        treatAsLostFont?: (fontName: string) => boolean;
    },
) => {
    const { treatAsLostFont } = options || {};

    const lost: string[] = [];

    sourceFonts.forEach((name) => {
        const isNotExists = !checkFontIsInEditor(name, editorFonts);

        if (isNotExists) {
            lost.push(name);
        } else {
            if (treatAsLostFont && treatAsLostFont(name)) {
                lost.push(name);
            }
        }
    });

    return lost;
};

export const alibabaFontReplaceToSourceHanSansCN = (fontFamily: string) => {
    if (fontFamily.includes('AlibabaPuHuiTi')) {
        return 'SourceHanSansCN-Regular';
    }
    return fontFamily;
};
